<div class="px-4 py-2 d-flex align-items-center gap-2">
  <a (click)="abort()">
    <app-svg-icon [type]="openedFromDashboard ? 'tiles' : 'arrow-left'" size="large"/>
  </a>
  <h2 class="modal-title">
    {{ 'configurationCreation.title' | translate }}
    @if (selectedTemplateTitle) {
      - {{ selectedTemplateTitle | translate }}
    }
  </h2>
</div>
<div class="mx-3 flex-grow-1 align-items-stretch">
  @if (currentWizard(); as currentWizard) {
    <app-wizard-layout [wizard]="currentWizard" [attr.data-testid]="'wizard-' + currentWizard.type"/>
  } @else {
    <app-type-selection
      [groups]="templates"
      (typeSelected)="startConfiguration($event)"
    />
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-cancel btn-secondary" (click)="abort()">
    {{ 'global.label.cancel' | translate }}
  </button>
  @if (currentWizard()) {
    <button type="button" class="btn btn-back btn-secondary"
            (click)="previousStep()"
            [class.event-disabled]="!isBackEnabled" [disabled]="!isBackEnabled">
      {{ 'global.label.step_backward' | translate }}
    </button>
    <button type="button" class="btn btn-primary btn-forward component-action"
            (click)="nextStep()"
            [class.event-disabled]="!submitEnabled" [disabled]="!submitEnabled" id="projectnavigation-submit" data-testid="projectnavigation-submit">
      {{ (isLastStep() ? 'global.label.project' : 'global.label.continue') | translate }}
    </button>
  }
</div>
